var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('RoundIcon',[_vm._t("icon")],2),_c('span',{staticClass:"box__text"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }